import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { IconKey, IconMail, IconUserCheck } from '@tabler/icons-react';
import { useAuth } from '../../auth/model/authStore';
import { FormField } from '../../../shared/ui/FormField';
import { TextInput } from '../../../shared/ui/TextInput';

interface FormValues {
  superEmail: string;
  superPassword: string;
}

interface Props {
  userId: string;
  userName: string;
  onClose: () => void;
}

const ImpersonateModal: React.FC<Props> = ({ userId, userName, onClose }) => {
  const { impersonateUser } = useAuth();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const onSubmit = async (data: FormValues) => {
    try {
      await impersonateUser(userId, data.superEmail, data.superPassword);
      navigate('/kanban');
    } catch {
      setError('superPassword', { message: 'Неверные данные суперпользователя' });
    }
  };

  return (
    <div className="mo open" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="adm-imp-modal">
        <div className="adm-imp-header">
          <div className="adm-imp-icon">
            <IconUserCheck size={20} stroke={2} />
          </div>
          <div>
            <div className="adm-imp-title">Войти как пользователь</div>
            <div className="adm-imp-sub">{userName}</div>
          </div>
        </div>

        <form className="adm-imp-body" onSubmit={handleSubmit(onSubmit)}>
          <p className="adm-imp-desc">
            Введите учётные данные суперпользователя PocketBase для подтверждения.
          </p>

          <FormField label="Email суперпользователя" error={errors.superEmail?.message}>
            <TextInput
              className="adm-input"
              controlClassName="control-with-icon"
              icon={<IconMail size={16} stroke={1.9} />}
              type="email"
              placeholder="super@example.com"
              {...register('superEmail', { required: 'Укажите email' })}
            />
          </FormField>

          <FormField label="Пароль суперпользователя" error={errors.superPassword?.message}>
            <TextInput
              className="adm-input"
              controlClassName="control-with-icon"
              icon={<IconKey size={16} stroke={1.9} />}
              type="password"
              placeholder="••••••••••"
              {...register('superPassword', { required: 'Укажите пароль' })}
            />
          </FormField>

          <div className="adm-form-actions">
            <button type="button" className="adm-btn-cancel" onClick={onClose}>
              Отмена
            </button>
            <button type="submit" className="adm-btn-save" disabled={isSubmitting}>
              {isSubmitting ? <><span className="adm-btn-spinner" />Вход...</> : 'Войти'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export { ImpersonateModal };
